<template>
    <section>
        <h3 class="section-title">Тест</h3>
        <div class="text-container valign">
            <div class="text-main">
                <p>Планируете провести выходные с шампуром в руке?<br>Ждете вечер пятницы, чтобы отправиться на дачу и
                    жарить там стейки до воскресенья? В нашем спецпроекте вы узнаете о том, какие рецепты вам подойдут,
                    а также о мерах, которые стоит принять, чтобы ваш организм не испытал белковую (и не только) перегрузку. </p>
            </div>
            <router-link to="/test" class="btn btn-hover" @click.native = "gaClickStart"><span>начать тест</span></router-link>
        </div>
        <div class="decoration-container decoration-container__test">
            <div class="layer layer__1" :style="{transform: 'rotate('+angle/3+'deg)'}">
                <transition name="fade-left-bottom" appear>
                <div class="circle"></div>
                </transition>
                <transition name="fade-right-top" appear>
                <div class="circle"></div>
                </transition>
            </div>
            <div class="layer layer__2" :style="{transform: 'rotate(-'+angle/3+'deg)'}">
                <transition name="fade-left-top" appear>
                    <div class="circle__bg"></div>
                </transition>
                <transition name="fade-left-bottom" appear>
                    <div class="circle__bg"></div>
                </transition>
                <transition name="fade-right-top" appear>
                    <div class="circle__bg"></div>
                </transition>
                <transition name="fade-right-bottom" appear>
                    <div class="circle__bg"></div>
                </transition>
            </div>
            <div class="layer layer__3" :style="{transform: 'rotate('+angle+'deg)'}">
                <transition name="fade-left-top" appear>
                    <Item1></Item1>
                </transition>
                <transition name="fade-right-bottom" appear>
                    <Item2></Item2>
                </transition>
                <transition name="fade-left-bottom" appear>
                    <img src="/static/images/item-5-2.png" alt="Item">
                </transition>
                <transition name="fade-left-bottom" appear>
                    <img src="/static/images/item-7-1.png" alt="Item">
                </transition>
                <transition name="fade-right-top" appear>
                    <img src="/static/images/item-4-1.png" alt="Item">
                </transition>
            </div>
        </div>
    </section>
</template>

<script>
    import {TweenMax} from 'gsap';
    import Item1 from '../../assets/svg/item-5.svg';
    import Item2 from '../../assets/svg/item-6.svg';
    export default {
        name: 'Test',
        components: {
            Item1,
            Item2
        },
        data () {
            return {
                angle: 0
            }
        },
        methods: {
            gaClickStart(){
                ga('send', 'event', 'click', 'show', 'Test page click Start');
            }
        },
        mounted(){
            let self = this;
            document.body.addEventListener('mousemove',function(e){
                self.angle = (e.clientX+e.clientY)/1000;
            })
        },
    }
</script>


// WEBPACK FOOTER //
// TestStart.vue?6c7b37dc